import type { RefObject } from 'react';
import { CarouselDots as KitCarouselDots } from '@voll-intelligence/intelligence-ui-kit';
import { useGenUiI18n, type GenUiKey } from '../../shared/ui/i18n.js';

export { CAROUSEL_RAIL, CAROUSEL_SLIDE } from '@voll-intelligence/intelligence-ui-kit';

/** Os pontos do carrossel do kit (#4997) com o nome de cada ponto do catálogo
 *  (`{{position}}`/`{{total}}`). */
export function CarouselDots({
  railRef,
  count,
  slideKey = 'flightOffers.slideAria',
}: {
  readonly railRef: RefObject<HTMLElement | null>;
  readonly count: number;
  readonly slideKey?: GenUiKey;
}) {
  const { t } = useGenUiI18n();
  return (
    <KitCarouselDots
      railRef={railRef}
      count={count}
      slideLabel={(position, total) => t(slideKey, { position, total })}
    />
  );
}
